export const queryForLatestDetectionsByReader = async (apiUrl, detectorSerial) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  return await fetch(`${apiUrl}${detectorSerial}/recent-tags`, requestOptions);
};
